'use client';

import { SessionProvider } from 'next-auth/react';
import { Session } from 'next-auth';
import React from 'react';

interface NextAuthClientProviderProps {
  children: React.ReactNode;
  session: Session | null;
}

/**
 * refetchOnWindowFocus: false — avoids session refetch on every navigation/focus
 * which can make pages appear to "load then reload" (re-render flash).
 * Session is still provided from server on initial load and can be refetched
 * explicitly where needed (e.g. after profile update).
 */
export default function NextAuthClientProvider({ children, session }: NextAuthClientProviderProps) {
  return (
    <SessionProvider session={session} refetchOnWindowFocus={false}>
      {children}
    </SessionProvider>
  );
}
